
      
       <!-- Default box -->
       <div class="card card-info"  [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Supplier Information</div> 
         <div class="row mt-2 ml-3">
          <div class="input-group col-md-8 "> 
          <mat-form-field class="example-form-field">
            <mat-label  [ngClass]="{'dark-bg' : isDark }">Search</mat-label>  
            <span matPrefix><i class="fas fa-search">&nbsp; &nbsp;</i></span>                    
            <input matInput type="text" autocomplete="off" [(ngModel)]="searchKey" (keyup)="applyFilter()">
            <span class="input-group-append" matSuffix>
              <button class="btn  border-0" type="button">
                  <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close"  [ngClass]="{'dark-bg' : isDark }"></i>
              </button>
            </span> 
          </mat-form-field>
          
          </div>

           <div class="col-md-4">
             <button  *ngIf="crud_access.create"  (click)="newButtonClick()" class="btn btn-success float-right mr-4"><i class="fa fa-plus p-1"></i>New</button>
           </div>      
         </div>
         <form class="form-horizontal">
         <fieldset>
         <div class="card-body">

          <div>
            <mat-table [dataSource]="dataSource" matSort>
             
              <ng-container matColumnDef="SupId">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> SupId </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.SupId}} </mat-cell>
              </ng-container>
                       
              <ng-container matColumnDef="SupName">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> SupName </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.SupName}} </mat-cell>
              </ng-container>
                      
              <ng-container matColumnDef="Phone">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> Phone </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.Phone}} </mat-cell>
              </ng-container>
                     
              <ng-container matColumnDef="Email">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> Email </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.Email}} </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="Status">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-center"  [ngClass]="{'dark-bg' : isDark }"> Status </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-center"  [ngClass]="{'dark-bg' : isDark }"> <span class="badge" [ngClass]="{'badge-success' : element.Status==='Active','badge-danger' : element.Status==='Deactivated' }">{{element.Status }}</span></mat-cell>
              </ng-container>

              <ng-container matColumnDef="CreatedBy">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> CreatedBy </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.CreatedBy}} </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="Action">
                <mat-header-cell *matHeaderCellDef  [ngClass]="{'dark-bg' : isDark }"> Action </mat-header-cell>
                <mat-cell *matCellDef="let row"  [ngClass]="{'dark-bg' : isDark }">
                  <button  *ngIf="crud_access.read"  class="btn btn-primary btn-sm  text-white" (click)="getRowData(row)" data-toggle="viewTooltip" data-placement="bottom" title="View"><i class="far fa-folder-open"></i></button>
                  <button  *ngIf="crud_access.delete"  class="btn btn-danger btn-sm ml-1 text-white"  (click)="deleteButtonClick(row.SupId)"  data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="far fa-trash-alt"></i></button>       
                </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="loading">
                <mat-footer-cell *matFooterCellDef colspan="6"  [ngClass]="{'dark-bg' : isDark }"> Loading data... </mat-footer-cell> 
              </ng-container>
  
              <ng-container matColumnDef="noData">
                <mat-footer-cell *matFooterCellDef colspan="6"  [ngClass]="{'dark-bg' : isDark }"> No data available in table </mat-footer-cell> 
              </ng-container>
            
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : dataSource!=null }"></mat-footer-row>
              <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide' : !(dataSource!=null && dataSource.data.length==0)}"></mat-footer-row>
            </mat-table>
  
            <mat-paginator  [ngClass]="{'dark-bg' : isDark }" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  
            </div>

         </div>                                
         <!-- /.card-body -->
       </fieldset>
         </form>
       </div>
     
   <script>
   
     $(function () {
     $('[data-toggle="viewTooltip"]').tooltip()
   })
   $(function () {
     $('[data-toggle="deleteTooltip"]').tooltip()
   })
   </script>

